import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import renderMermaidIn, { watchColorScheme } from './renderMermaid';
export { default as extend } from './extend';
app.initializers.add('datlechin-mermaid', () => {
  // Re-render mermaid blocks every time a CommentPost mounts or updates.
  // CommentPost is lazy-loaded in 2.x, so extend() takes the module path.
  // extend()'s callback signature is (this, returnValue, ...originalArgs),
  // and CommentPost's lifecycle hooks pass a VnodeDOM as their only arg.
  const onPostRender = function (_) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    const vnode = args[0];
    renderMermaidIn(vnode.dom).catch(err => console.error('[datlechin-mermaid]', err));
  };
  extend('flarum/forum/components/CommentPost', 'oncreate', onPostRender);
  extend('flarum/forum/components/CommentPost', 'onupdate', onPostRender);
  watchColorScheme();
});